<template>
<div class="p-2 text-center text-gray-300 font-valorant md:p-4">


  <h3 class="text-xl text-red-500 mt-3">your free tiMe is vAluable.</h3>
  <h3 class="text-lg"><span class="text-red-500">don'T wAste it</span> by grinding pAinfully through the ranks you <span class="text-red-500">know</span> you're not in.</h3>

  <h3 class="text-xl text-red-500 mt-4">your skills Are vAluable.</h3>
  <h3 class="text-lg">It's time for you to get <span class="text-red-500">pAid</span> by doing what you <span class="text-red-500">love</span></h3>


  <h1 class="text-4xl mt-6">How it works</h1>

  <h3 class="text-3xl text-red-500">Buyers</h3>
  <h5 class="text-xl">stArt plAying in As little As 30 Minutes</h5>

<ul class="flex flex-grow justify-center flex-col w-full m-auto font-valorant sm:flex-row md:w-5/6 xl:w-3/4">
  <li class="flex-1 m-4  border border-white rounded">
    
    <i class="fa fa-3x fa-google p-4 text-red-500" aria-hidden="true"></i>
    <p>Go to 'Your <span class="text-red-500">v</span>A.net Account' and login with Google</p>
  </li>

    <li class=" flex-1 m-4  border border-white rounded">
      <i class="pf pf-ltc pf-3x p-4 text-red-500"></i>
      <p>set your litecoin Address for pAyMents and refunds</p>
      <p class="mt-2 text-sm">We use litecoin becAuse it's quick, sAfe, and hAs the lowest fees.</p> 
 </li>

  <li class="flex-1 m-4 border border-white rounded scrolling-touch overflow-y-auto">
    <i class="fa fa-list-ol p-4 fa-3x text-red-500" aria-hidden="true"></i>
    <p>Search our listings for the perfect Account</p>
    <p class="mt-2 text-sm">All listings hAve info on region, hArdwAre, and More!</p>
 </li>

</ul>

<ul class="flex justify-center flex-col w-full m-auto font-valorant sm:flex-row md:w-5/6 xl:w-3/4">
  <li class="flex-1 m-4  border border-white rounded">
    
    <i class="fa fa-address-card p-4 fa-3x text-red-500" aria-hidden="true"></i>

    <p>After pAyMent, the login details Are sent AutoMaticAlly</p>
    
  </li>


  <li class="flex-1 m-4 border border-white rounded">
    <i class="fa fa-check p-4 fa-3x text-red-500" aria-hidden="true"></i>
    <p class="">If the login detAils work, the seller gets their pAyMent</p>
 </li>
    <li class=" flex-1 m-4  border border-white rounded">
      <i class="fa fa-3x p-4 text-red-500 fa-user-secret" aria-hidden="true"></i>
      <p>If there's any issues we return 100% of the litecoin to the Address it wAs sent from.</p> 
      <p class="mt-2 text-sm">we'll even pAy the transaction fees!</p>
 </li>
</ul>

  <h3 class="text-3xl text-red-500">Sellers</h3>
  <h5 class="text-xl">get pAid in As little As 30 Minutes</h5>

<ul class="flex flex-grow justify-center flex-col w-full m-auto font-valorant sm:flex-row md:w-5/6 xl:w-3/4">
  <li class="flex-1 m-4  border border-white rounded">
    
    <i class="fa fa-3x fa-google p-4 text-red-500" aria-hidden="true"></i>
    <p>Go to 'Your <span class="text-red-500">v</span>A.net Account' and login with Google</p>
    

  </li>


  <li class="flex-1  m-4 border border-white rounded scrolling-touch overflow-y-auto">
    <i class="fa fa-user-plus p-4 fa-3x text-red-500" aria-hidden="true"></i>
    <p>Apply to becoMe A Seller</p>
    <p class="text-sm mt-2 p-1">To protect our buyers, you Must pAy A $3 USD fee to begin Adding listings</p>
 </li>
    <li class=" flex-1 m-4  border border-white rounded">
      <i class="fa fa-list fa-3x p-4 text-red-500"></i>
      <p>Add your listing</p>
      <p class="mt-2 text-sm">Make yourself stand out As A seller by providing extra info like hArdwAre and location</p>
</li>
</ul>

<ul class="flex flex-grow justify-center flex-col w-full m-auto font-valorant sm:flex-row md:w-5/6 xl:w-3/4">
  <li class="flex-1 m-4  border border-white rounded">
    
    <i class="fa fa-3x fa-forward p-4 text-red-500" aria-hidden="true"></i>
    <p class="p-1 text-sm">(optional)</p>
    <p><span class="text-red-500">boost</span> or <span class="text-yellow-500">sponsor</span> your listing to the top of the results for A Miniscule extra fee</p>
    

  </li>


  <li class="flex-1 m-4 border border-white rounded scrolling-touch overflow-y-auto">
    <i class="fa fa-handshake-o p-4 fa-3x text-red-500" aria-hidden="true"></i>
    <p>once A buyer hAs sent litecoin, they get the Account detAils</p>
</li>
    <li class=" flex-1 m-4  border border-white rounded">
      <i class="fa fa-money fa-3x p-4 text-red-500"></i>
      <p>After confirMAtion, the litecoin is pAid out to the Address you hAve set!</p>
</li>
</ul>

  <h1 class="text-4xl mt-6">Still concerned?</h1>
  <h5 class="text-md font-sans">Read more on how we protect Buyers and Sellers below:</h5>

  <BuyerSellerVanguard />
  
  <BuySellContact />


</div>
</template>

<script>
import moment from 'moment'

import BuyerSellerVanguard from './BuyerSellerVanguard'
import BuySellContact from './BuySellContact'

import firebase from 'firebase/app'

import db from '@/db'

import * as firebaseui from 'firebaseui'

import 'firebaseui/dist/firebaseui.css'

export default {
  name: 'Home',
  data() {
    return {
      moment: ''
    }
  },
  components: {BuyerSellerVanguard, BuySellContact},
 beforeMount(){



   this.moment = moment()
 },
 mounted: function () {
   // Initialize the FirebaseUI Widget using Firebase.

 }    

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Home.vue